import { create } from 'zustand'

export interface PositionUpdate {
  locationName: string
  floor: number
  battery: number
  rssi: number
  timestamp: number
}

export interface TopologyNode {
  id: string
  x: number
  z: number
  floor: number
}

export interface TopologyEdge {
  from: string
  to: string
  rssi: number
}

interface RealtimeState {
  connected: boolean
  lastUpdate: number | null
  positions: Map<string, PositionUpdate>
  batteries: Map<string, number>
  topologyNodes: TopologyNode[]
  topologyEdges: TopologyEdge[]
  // Filter state
  showBatteries: boolean
  showTopology: boolean
  showOptimalOnly: boolean
  filterOffline: boolean
  rssiThreshold: number
  setConnected: (connected: boolean) => void
  updatePosition: (badgeCode: string, data: PositionUpdate) => void
  updateBattery: (badgeCode: string, battery: number) => void
  updateTopology: (nodes: TopologyNode[], edges: TopologyEdge[]) => void
  setShowBatteries: (v: boolean) => void
  setShowTopology: (v: boolean) => void
  setShowOptimalOnly: (v: boolean) => void
  setFilterOffline: (v: boolean) => void
  setRssiThreshold: (v: number) => void
  clearPositions: () => void
}

export const useRealtimeStore = create<RealtimeState>((set, get) => ({
  connected: false,
  lastUpdate: null,
  positions: new Map(),
  batteries: new Map(),
  topologyNodes: [],
  topologyEdges: [],
  showBatteries: false,
  showTopology: false,
  showOptimalOnly: false,
  filterOffline: false,
  rssiThreshold: -90,

  setConnected: (connected) => set({ connected }),

  updatePosition: (badgeCode, data) => {
    const positions = new Map(get().positions)
    positions.set(badgeCode, data)
    const batteries = new Map(get().batteries)
    batteries.set(badgeCode, data.battery)
    set({ positions, batteries, lastUpdate: Date.now() })
  },

  updateBattery: (badgeCode, battery) => {
    const batteries = new Map(get().batteries)
    batteries.set(badgeCode, battery)
    set({ batteries })
  },

  updateTopology: (nodes, edges) => {
    set({ topologyNodes: nodes, topologyEdges: edges })
  },

  setShowBatteries: (v) => set({ showBatteries: v }),
  setShowTopology: (v) => set({ showTopology: v }),
  setShowOptimalOnly: (v) => set({ showOptimalOnly: v }),
  setFilterOffline: (v) => set({ filterOffline: v }),
  setRssiThreshold: (v) => set({ rssiThreshold: v }),

  clearPositions: () => set({
    positions: new Map(),
    batteries: new Map(),
    topologyNodes: [],
    topologyEdges: [],
    lastUpdate: null,
  }),
}))
